export default __webpack_public_path__ + "static/media/carto-logo-xs.5b24a36a.svg";